import React from "react";
import PropTypes from "prop-types";
import FlipNumbers from 'react-flip-numbers';



const MerchantImpactTicker = ({ fetchedImpact }) => {

    const displayImpact = (title, message, number, unit, img) => <>
        <div>
            <div>
                {/*message ? <Popover overlayStyle={{width: 350}} className="popover-question" content={message} title={<b>Tree Growth Years</b>}>
                    <span className="small-capitalized-text">{title.toLowerCase()}</span>
</Popover> : <span className="small-capitalized-text">{title.toLowerCase()} </span>*/}

                <div>
                    <h2 className="font-bold color-green d-flex w-fit center">
                        <FlipNumbers numberStyle={{ fontSize: 18, color: "#2AA43C", fontWeight: "bold" }} height={34} width={20} play perspective={100} numbers={Math.floor(number).toLocaleString()} />
                        <span>{unit}</span>
                    </h2>
                    <h5 className="font-bold color-primary">{title}</h5>
                </div>
            </div>
        </div> </>;

    return (
        <>
            <div className="merchant-impact-section">
               
                <div className="d-flex w-100 justify-center mobile-d-block">
                    <div className="py-3 px-4">
                        <div>
                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/c_scale,h_180/v1620859304/Enterprise/Round%20Theory%20/Rt-2_xw91c6.png`} />
                        </div>
                        {displayImpact('Glasses of wine made climate friendly', null, fetchedImpact.impactProgress.wineGlasses.currentCount, null, null)}
                    </div>
                    <div className="py-3 px-4">
                        <div>
                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/c_scale,h_180/v1620859303/Enterprise/Round%20Theory%20/Rt-1_ytngju.png`} />
                        </div>
                        {displayImpact('Total offsets', null, fetchedImpact.impactProgress.carbonOffset.currentCount, 'KG', null)}
                    </div>
                    <div className="py-3 px-4">
                        <div>
                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1620861401/Enterprise/Round%20Theory%20/image_64_jinopp.png`} />
                        </div>
                        {displayImpact('Tree Growth Years', `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${Math.floor(fetchedImpact.impactProgress.treeGrowthYears.currentCount).toLocaleString()} trees have in one year.`,
                            fetchedImpact.impactProgress.treeGrowthYears.currentCount, null, null)}
                    </div>
                </div>
            </div>
        </>
    );
};

MerchantImpactTicker.propTypes = {
    fetchedImpact: PropTypes.object
};


export default MerchantImpactTicker;
